// Shared inline styles for public content pages (landing, projects,
// knowledge). Keeps the premium dark/gold Hestia look consistent.

export const pageStyle = {
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #2d2d2d 100%)',
  paddingTop: '4rem'
};

export const containerStyle = {
  maxWidth: '72rem',
  margin: '0 auto',
  padding: '3rem 1.5rem'
};

export const highlightStyle = { color: '#dfa926' };

export const cardStyle = {
  background: 'linear-gradient(135deg, rgba(26, 26, 26, 0.5) 0%, rgba(17, 17, 17, 0.5) 100%)',
  border: '1px solid rgba(58, 58, 58, 0.5)',
  borderRadius: '0.75rem',
  overflow: 'hidden',
  textDecoration: 'none'
};

export const ctaButtonStyle = {
  display: 'inline-block',
  backgroundColor: '#dfa926',
  color: 'black',
  fontWeight: 600,
  padding: '1rem 2.5rem',
  borderRadius: '0.5rem',
  textDecoration: 'none'
};

export const h1Style = {
  fontSize: '3rem',
  fontWeight: 'bold',
  color: 'white',
  marginBottom: '1.25rem',
  maxWidth: '56rem'
};

export const introStyle = {
  fontSize: '1.25rem',
  color: '#d1d5db',
  maxWidth: '48rem',
  lineHeight: 1.7,
  marginBottom: '2.5rem'
};

export const h2Style = {
  ...highlightStyle,
  fontSize: '1.5rem',
  fontWeight: 600,
  marginBottom: '1.25rem'
};

export const bodyTextStyle = { color: '#d1d5db', lineHeight: 1.7 };

export const breadcrumbStyle = { marginBottom: '1.5rem', fontSize: '0.875rem' };

export const breadcrumbListStyle = {
  listStyle: 'none',
  display: 'flex',
  gap: '0.5rem',
  padding: 0,
  margin: 0,
  flexWrap: 'wrap'
};

export const breadcrumbLinkStyle = { color: '#9ca3af', textDecoration: 'none' };

export const bulletDot = {
  width: '0.5rem',
  height: '0.5rem',
  backgroundColor: '#dfa926',
  borderRadius: '50%',
  marginTop: '0.4rem',
  marginRight: '0.75rem',
  flexShrink: 0
};
